var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationCircleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "#D02B20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4016 28.0001C50.4016 40.3713 40.3727 50.4001 28.0016 50.4001C15.6304 50.4001 5.60156 40.3713 5.60156 28.0001C5.60156 15.6289 15.6304 5.6001 28.0016 5.6001C40.3727 5.6001 50.4016 15.6289 50.4016 28.0001ZM28.0016 14.0001C29.1614 14.0001 30.1016 14.9403 30.1016 16.1001V28.7001C30.1016 29.8599 29.1614 30.8001 28.0016 30.8001C26.8418 30.8001 25.9016 29.8599 25.9016 28.7001V16.1001C25.9016 14.9403 26.8418 14.0001 28.0016 14.0001ZM28.0016 42.0001C29.548 42.0001 30.8016 40.7465 30.8016 39.2001C30.8016 37.6537 29.548 36.4001 28.0016 36.4001C26.4552 36.4001 25.2016 37.6537 25.2016 39.2001C25.2016 40.7465 26.4552 42.0001 28.0016 42.0001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircleIcon);
export default __webpack_public_path__ + "static/media/ExclamationCircleIcon.fb175b9f0d826f41434b8af6feb15a75.svg";
export { ForwardRef as ReactComponent };